import mapboxgl from "mapbox-gl";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import supabase from "../../services/supabase";
import "./Regions.css";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export default function Regions() {
    const mapRef = useRef(null);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [bayCount, setBayCount] = useState(0);
    const [davisCount, setDavisCount] = useState(0);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const fetchCounts = async () => {
        const { count: bay, error: bayError } = await supabase
            .from("bay_places")
            .select("*", { count: "exact", head: true });
        if (bayError) console.error("Error fetching bay_places count:", bay);
        else setBayCount(bay || 0);

        const { count: davis, error: davisError } = await supabase
            .from("places")
            .select("*", { count: "exact", head: true });
        if (davisError) console.error("Error fetching places count:", davis);
        else setDavisCount(davis || 0);
        };

        fetchCounts();
    }, []);

    useEffect(() => {
    const map = new mapboxgl.Map({
        container: mapRef.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: [-121.4179, 37.9], // centered to cali
        zoom: 7.2,
    });

    const regionMarkers = [
        {
            name: "Bay Area",
            count: bayCount,
            coordinates: [-122.3, 37.6],
            route: "/bayarea",
        },
        {
            name: "Davis",
            count: davisCount,
            coordinates: [-121.75, 38.55],
            route: "/localmap",
        },
    ];

    regionMarkers.forEach(({ name, count, coordinates, route }) => {
        const el = document.createElement("div");
        el.className = "region-marker";
        el.dataset.route = route;
        el.innerHTML = `<div class="region-circle"><strong>${name}</strong><br>${count}</div>`;
        el.addEventListener("click", () => {
            navigate(route);
        });

        new mapboxgl.Marker(el).setLngLat(coordinates).addTo(map);
    });

    return () => map.remove();
    }, [bayCount, davisCount]);

    const renderSidebarContent = () => (
        <div className="bottom-sheet-content">
            <h2 className="sidebar-title">Where do you want to go?</h2>
            <div className="button-card-list">
            <div className="card-button" onClick={() => navigate("/bayarea")}>
                <div className="card-icon">🌉</div>
                <div className="card-label">Bay Area</div>
            </div>
            <div className="card-button" onClick={() => navigate("/localmap")}>
                <div className="card-icon">🎓</div>
                <div className="card-label">Davis</div>
            </div>
            </div>
            <button
            className="text-button"
            onClick={() =>
                window.open("https://forms.gle/kioPS6GUkbFyY6vZ9", "_blank")
            }
            >
                Want to see your own spot on the map? Click here!
            </button>
            <button
            className="text-button"
            onClick={() =>
                window.open("https://forms.gle/rKazR4WUyZzLavXQ8", "_blank")
            }
            >
            Want a Pioneer Map for a different city? Click here!
            </button>
            <button
            className="text-button"
            onClick={() =>
                window.open("https://forms.gle/8F3o8UTQvznu2vVj6", "_blank")
            }
            >
            Recommend a name for our penguin mascot!
            </button>
            <a
            href="https://instagram.com/pioneer_official_1"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-button"
            >
            <img
                src="/Instagram-icon.png"
                alt="Instagram"
                className="instagram-icon"
            />
            Our Instagram
            </a>
            <p>Contact us: officialpioneer0430@gmail.com</p>
        </div>
    );



    return (
        <div className="app-container">
        <div className="map-wrapper">
            <div className="map-container" ref={mapRef}></div>

            {!isMobile ? (
            <div className="styled-sidebar">{renderSidebarContent()}</div>
            ) : (
            <BottomSheet
                open={true}
                defaultSnap={({ maxHeight }) => maxHeight * 0.3}
                snapPoints={({ maxHeight }) => [
                maxHeight * 0.25,
                maxHeight * 0.5,
                maxHeight * 0.9,
                ]}
                blocking={false}
                expandOnContentDrag
                scrollLocking={true}
                header={<div className="bottom-sheet-header" />}
            >
                {renderSidebarContent()}
            </BottomSheet>
            )}
        </div>
        </div>
    );
}